import { api } from "./api";

const baseUrl = 'visit'

export const getLastVisitDate = () => {
  return api.get(`${baseUrl}/last-date`).then(res => res.data.data)
}

export const recordVisit = () => {
  return api.post(`${baseUrl}`)
}

export const getVisitStats = (from: string, to: string) => {
  return api.get(`${baseUrl}/stats`, { params: { from, to } }).then(res => res.data.list)
}